module.exports = __webpack_public_path__ + "f281e347c41ec6f3325490364cfe93bb.MP3";